/**
 * CashSessions (Caja Z/X) — página standalone.
 * Cuadre de turno de cajero (apertura, cierre, Z-report).
 */
import { PageContainer, PageHeader } from "@/components/PageHeader";
import { CashTab } from "@/pages/AmeliaHub";

export default function CashSessions() {
  return (
    <PageContainer>
      <PageHeader
        title="Caja Z / X"
        subtitle="Apertura y cierre de turno de cajero con cuadre por denominaciones."
        testid="cash-sessions-header"
      />
      <div className="mt-4">
        <CashTab />
      </div>
    </PageContainer>
  );
}
